import { Box, Stack, Typography } from '@mui/material'
import React from 'react'
import { imgFallback } from '../../../helpers/imgFallback'
import { useScreenSize } from '../../../hooks/useScreenSize'
import { FramedAvatar } from '../../../sharedComponents/src/globalHeader/components/FramedAvatar'
import { useStoreState } from '../../../store/hooks'

const ProfileBlock: React.FC = () => {
    const { isMobile } = useScreenSize()
    const user = useStoreState((state) => state.userData.userData)

    const tags = user?.title ? user.title.split(',') : []

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                flexDirection: { xs: 'row', md: 'column' },
                gap: '16px',
                width: '100%',
                mb: 1,
            }}
        >
            <FramedAvatar
                avatar={user?.avatar_url || ''}
                season={user?.reward.season}
                reward={user?.reward.tier}
                sx={{
                    borderColor: 'primary.main',
                    borderRadius: '12px',
                    width: { xs: '66px', md: '200px' },
                    height: { xs: '66px', md: '200px' },
                    mb: user?.reward.tier ? { xs: 0, md: 3 } : 0,
                    color: 'background.default',
                }}
            />
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: { xs: 'flex-start', md: 'center' },
                    gap: 1,
                    flex: 1,
                }}
            >
                {/* User name */}
                <Typography variant="h5" color="primary.main" textTransform="uppercase">
                    {user?.user_name}
                </Typography>

                <Stack direction="row" gap="12px" height={{ xs: '30px', md: '44px' }} alignItems="center">
                    {/* Use country flag instead of name */}
                    <img
                        src={`/flags/${user?.country || 'WORLD'}@2x.png`}
                        onError={imgFallback}
                        alt={'flag icon'}
                        style={{ height: '100%', width: '100%', borderRadius: '6px' }}
                    />

                    {/* User tags and rewards */}
                    {user?.botd_reward_url || tags.length > 0 ? (
                        <Stack height="100%" direction="row" gap={1} alignItems="center">
                            {tags.map((tag, index) => (
                                <Box
                                    sx={{
                                        p: '0 12px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        height: { xs: '30px', md: '44px' },
                                        border: '2px solid',
                                        borderRadius: '6px',
                                    }}
                                    key={index}
                                >
                                    <Typography variant={isMobile ? 'h6' : 'h5'} textTransform="uppercase">
                                        {tag}
                                    </Typography>
                                </Box>
                            ))}
                            {user?.botd_reward_url && (
                                <img height="100%" src={user.botd_reward_url} alt={'Bot of the day reward'} />
                            )}
                        </Stack>
                    ) : null}
                </Stack>
            </Box>
        </Box>
    )
}

ProfileBlock.displayName = 'ProfileBlock'

export default ProfileBlock
